import { Box, Button, Flex, Heading, Spinner, Text } from "@chakra-ui/react";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useHomeLabel } from "../useHomeLabel";

interface Props {
  titleKey: string;
  seeAllTo?: string;
  isLoading?: boolean;
  isError?: boolean;
  isEmpty?: boolean;
  emptyKey: string;
  children: ReactNode;
}

export const HomePanel = ({ titleKey, seeAllTo, isLoading, isError, isEmpty, emptyKey, children }: Props) => {
  const { t } = useTranslation();
  const homeLabel = useHomeLabel();
  const navigate = useNavigate();
  return (
    <Box bg="smBackground" rounded="2xl" border="1px solid" borderColor="smBorder" overflow="hidden">
      <Flex align="center" justify="space-between" px="4" py="3" borderBottom="1px solid" borderColor="smBorder">
        <Heading as="h2" size="sm" color="smText">{homeLabel(titleKey)}</Heading>
        {seeAllTo && <Button variant="link" size="sm" colorScheme="teal" onClick={() => navigate(seeAllTo)}>{t("See all")} →</Button>}
      </Flex>
      {isLoading ? (
        <Flex py="12" justify="center"><Spinner color="smPrimary" /></Flex>
      ) : isError ? (
        <Flex py="12" justify="center"><Text color="smError">{t("Could not load data.")}</Text></Flex>
      ) : isEmpty ? (
        <Flex py="12" justify="center"><Text color="smMuted" fontSize="sm">{homeLabel(emptyKey)}</Text></Flex>
      ) : (
        children
      )}
    </Box>
  );
};
